import {
  CalendarDays,
  Shapes,
  Tag,
  Target,
  type LucideIcon,
} from 'lucide-react';
import { MOBILLS_NAV_ICONS, type AppIcon } from '@/components/ui/MobillsIcon';

export interface NavItem {
  to: string;
  label: string;
  icon: AppIcon | LucideIcon;
  /** aparece na bottom nav do mobile. */
  mobile?: boolean;
}

export const NAV: NavItem[] = [
  { to: '/', label: 'Principal', icon: MOBILLS_NAV_ICONS.home, mobile: true },
  { to: '/transacoes', label: 'Transações', icon: MOBILLS_NAV_ICONS.transactions, mobile: true },
  { to: '/cartoes', label: 'Cartões', icon: MOBILLS_NAV_ICONS.cards, mobile: true },
  { to: '/contas', label: 'Contas', icon: MOBILLS_NAV_ICONS.accounts },
  { to: '/calendario', label: 'Calendário', icon: CalendarDays },
  { to: '/categorias', label: 'Categorias', icon: Shapes },
  { to: '/tags', label: 'Tags', icon: Tag },
  { to: '/relatorios', label: 'Relatórios', icon: MOBILLS_NAV_ICONS.reports },
  { to: '/orcamentos', label: 'Orçamentos', icon: Target },
  { to: '/mais', label: 'Mais', icon: MOBILLS_NAV_ICONS.more, mobile: true },
];
